import { render, staticRenderFns } from "./TerminOverviewComp.vue?vue&type=template&id=4ded7e42&scoped=true&"
import script from "./TerminOverviewComp.vue?vue&type=script&lang=ts&"
export * from "./TerminOverviewComp.vue?vue&type=script&lang=ts&"
import style0 from "./TerminOverviewComp.vue?vue&type=style&index=0&id=4ded7e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ded7e42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VFlex,VLayout,VList,VPagination,VProgressCircular})
